export default "__VITE_ASSET__CgI_AlrU__"